import { normalizeMapBounds } from "#ce/components/SpFinder/engine/map-bounds";
/** Returns normalized bounds from a serialized or object value, or undefined when it cannot be read. */
export function parseMapBounds(value) {
  try {
    return normalizeMapBounds(typeof value === "string" ? JSON.parse(value) : value);
  } catch {
    return undefined;
  }
}
